import React from 'react';
import { useIntl } from 'react-intl';
import { Breadcrumbs, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import OutlineForm from '../OutlineForm';
import PageLayout from '../../PageLayout';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: '#F8F8F8',
  },
  toolbar: {
    backgroundColor: '#F8F8F8',
    zIndex: 1,
  },
  toolbarTitle: {
    color: '#F79A56',
    flexGrow: 1,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    backgroundColor: '#F8F8F8',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(2),
    },
  },
}));

function NewOutlinePage() {
  const classes = useStyles();
  const intl = useIntl();
  const newOutlineText = intl.formatMessage({ id: 'outline.newTitle', defaultMessage: 'Nuevo perfil' });
  const outlinesText = intl.formatMessage({ id: 'outline.outlinesText', defaultMessage: 'Perfiles' });

  function NewOutlineBreadcrumbs() {
    return (
      <Breadcrumbs className={classes.breadcrumbs} separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/outlines" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{outlinesText}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{newOutlineText}</strong></Typography>
      </Breadcrumbs>
    );
  }

  return (
    <PageLayout title={newOutlineText} breadCrumbs={<NewOutlineBreadcrumbs />}>
      <OutlineForm />
    </PageLayout>
  );
}

export default NewOutlinePage;
